module.exports = __webpack_public_path__ + "Lato-Italic.56c4cb26fd6a48b9c0eb";


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/assets/fonts/Lato/Lato-Italic.ttf
// module id = ../../../../../src/assets/fonts/Lato/Lato-Italic.ttf
// module chunks = styles